/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MenuItemVariantDto } from './MenuItemVariantDto';
import {
    MenuItemVariantDtoFromJSON,
    MenuItemVariantDtoFromJSONTyped,
    MenuItemVariantDtoToJSON,
} from './MenuItemVariantDto';

/**
 * 
 * @export
 * @interface MenuSubSectionDto
 */
export interface MenuSubSectionDto {
    /**
     * 
     * @type {string}
     * @memberof MenuSubSectionDto
     */
    id: string;
    /**
     * 
     * @type {Array<MenuItemVariantDto>}
     * @memberof MenuSubSectionDto
     */
    items: Array<MenuItemVariantDto>;
    /**
     * 
     * @type {string}
     * @memberof MenuSubSectionDto
     */
    sectionType: string;
    /**
     * 
     * @type {string}
     * @memberof MenuSubSectionDto
     */
    sectionOwnerName: string;
    /**
     * 
     * @type {number}
     * @memberof MenuSubSectionDto
     */
    sectionOwnerLocationId: number;
    /**
     * 
     * @type {string}
     * @memberof MenuSubSectionDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof MenuSubSectionDto
     */
    sequence: number;
    /**
     * 
     * @type {boolean}
     * @memberof MenuSubSectionDto
     */
    active: boolean;
    /**
     * 
     * @type {number}
     * @memberof MenuSubSectionDto
     */
    productCount: number;
}

/**
 * Check if a given object implements the MenuSubSectionDto interface.
 */
export function instanceOfMenuSubSectionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "sectionType" in value;
    isInstance = isInstance && "sectionOwnerName" in value;
    isInstance = isInstance && "sectionOwnerLocationId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "sequence" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "productCount" in value;

    return isInstance;
}

export function MenuSubSectionDtoFromJSON(json: any): MenuSubSectionDto {
    return MenuSubSectionDtoFromJSONTyped(json, false);
}

export function MenuSubSectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuSubSectionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'items': ((json['items'] as Array<any>).map(MenuItemVariantDtoFromJSON)),
        'sectionType': json['sectionType'],
        'sectionOwnerName': json['sectionOwnerName'],
        'sectionOwnerLocationId': json['sectionOwnerLocationId'],
        'name': json['name'],
        'sequence': json['sequence'],
        'active': json['active'],
        'productCount': json['productCount'],
    };
}

export function MenuSubSectionDtoToJSON(value?: MenuSubSectionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'items': ((value.items as Array<any>).map(MenuItemVariantDtoToJSON)),
        'sectionType': value.sectionType,
        'sectionOwnerName': value.sectionOwnerName,
        'sectionOwnerLocationId': value.sectionOwnerLocationId,
        'name': value.name,
        'sequence': value.sequence,
        'active': value.active,
        'productCount': value.productCount,
    };
}

